import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Input, Button, Row, Col } from 'reactstrap';
import { toast } from 'react-toastify';
import api from '../../config/configAPI';
import DefaultModal from 'components/Modal/DefaultModal';
import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';
import { Tooltip } from 'reactstrap';
import { FaInfoCircle } from 'react-icons/fa';
import { ObjectId } from 'bson';

const GroupUploadFileModal = ({ isOpen, onClose, groupId, sender }) => {
  const [file, setFile] = useState(null);
  const [isSending, setIsSending] = useState(false);
  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSend = async () => {
    if (!file) {
      toast.error('Selecione um arquivo!');
      return;
    }

    const mensagemId = new ObjectId().toHexString();

    const formData = new FormData();
    formData.append('file', file);
    formData.append('groupId', groupId);
    formData.append('sender', sender);
    formData.append('type', 'file');
    formData.append('messageId', mensagemId);

    setIsSending(true);
    try {
      const res = await api.post('/groups/file', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      toast.success('Arquivo enviado com sucesso!');
      onClose();
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Erro ao enviar o arquivo';

      console.error('Erro no envio do arquivo:', message);
      toast.error('Erro ao enviar o arquivo');
    } finally {
      setIsSending(false);
    }
  };

  return (
    <DefaultModal
      show={isOpen}
      onModalToggle={(visible) => {
        if (!visible) onClose();
      }}
      title="Enviar Arquivo"
      showCloseButton={false}
      modalContainerClasses="modal-sm"
    >
      <hr style={{ marginTop: '-30px' }} />

      <label
        htmlFor="uploadFile"
        className="btn btn-primary btn-sm"
        style={buttonStyle(systemConfiguration.confirmation_button_color)}
      >
        {file ? 'Escolher outro' : 'Selecionar arquivo'}
      </label>

      <div className="mt-2 d-flex justify-content-center align-items-center gap-2">
        <small className="text-muted">
          Limite máximo: <strong>10MB</strong>
        </small>

        <FaInfoCircle
          id="fileInfoIcon"
          style={{ cursor: 'pointer', marginLeft: '5px' }}
        />

        <Tooltip
          placement="top"
          isOpen={tooltipOpen}
          target="fileInfoIcon"
          toggle={() => setTooltipOpen(!tooltipOpen)}
        >
          <div style={{ fontSize: '13px', lineHeight: '1.4', maxWidth: 240 }}>
            <strong>Tipos de arquivos suportados:</strong>
            <ul style={{ paddingLeft: '1rem', margin: 0 }}>
              <li>
                <strong>Imagens:</strong> JPG, JPEG, PNG, GIF, BMP, WEBP
              </li>
              <li>
                <strong>Áudios:</strong> MP3, WAV, OGG, MPEG, AAC
              </li>
              <li>
                <strong>Vídeos:</strong> MP4, WEBM, MOV
              </li>
              <li>
                <strong>Documentos:</strong> PDF, DOC, DOCX, XLS, XLSX, PPT,
                PPTX
              </li>
            </ul>
          </div>
        </Tooltip>
      </div>

      <Input
        type="file"
        id="uploadFile"
        name="uploadFile"
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />

      {file && (
        <div className="mt-3 text-center">
          <p>Arquivo selecionado:</p>
          <strong>{file.name}</strong>
        </div>
      )}

      <Row className="mt-4">
        <Col className="d-flex justify-content-center gap-2">
          <Button
            onClick={handleSend}
            disabled={!file || isSending}
            style={buttonStyle(systemConfiguration.confirmation_button_color)}
          >
            {isSending ? 'Enviando...' : 'Enviar'}
          </Button>

          <Button
            onClick={onClose}
            style={buttonStyle(systemConfiguration.cancelation_button_color)}
          >
            Cancelar
          </Button>
        </Col>
      </Row>
    </DefaultModal>
  );
};

export default GroupUploadFileModal;
